import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import EmailBack from './EmailBack.jsx';
import ProductsListItemWithIntersectionDetection
  from './ProductsListItemWithIntersectionDetection.jsx';
import { getCurrentProductList } from '../helpers';
import ProductFlexibleCreditTooltip, { listViewPositionHandler }
  from './ProductFlexibleCreditTooltip.jsx';
import translations from '../translations';

class ProductList extends PureComponent {
  constructor(props) {
    super(props);
    this.setFlexibleCreditAnchorRef = this.setFlexibleCreditAnchorRef.bind(this);
  }

  setFlexibleCreditAnchorRef(ref) {
    this.flexibleCreditAnchorRef = ref;
  }

  render() {
    let productView;
    const { props } = this;
    const productItems = props.productsList.map((currentProduct) => {
      productView = [
        <ProductsListItemWithIntersectionDetection
          {...currentProduct}
          countdownClassSuffix={props.countdownClassSuffix}
          key={currentProduct.id}
          translations={translations}
          setFlexibleAnchorRefToParent={this.setFlexibleCreditAnchorRef}
          dataInteraction={props.dataInteraction}
          onIntersection={props.onProductIntersection}
          displayCompare
        />];

      if (currentProduct.id === props.emailWhenBackFormProductID) {
        productView.push(<EmailBack
          translations={translations.emailWhenBackForm}
          key={`email-back-${currentProduct.id}`}
        />);
      }

      return productView;
    });

    return (
      <>
        {this.props.flexibleCreditTooltipProductID && (
        <ProductFlexibleCreditTooltip
          productID={this.props.flexibleCreditTooltipProductID}
          flexibleCreditAnchorRef={this.flexibleCreditAnchorRef}
          positionHandler={listViewPositionHandler}
        />
        )}

        <div>
          {productItems}
        </div>
      </>
    );
  }
}

ProductList.displayName = 'ProductList';

ProductList.propTypes = {
  productsList: PropTypes.arrayOf(PropTypes.object).isRequired,
  countdownClassSuffix: PropTypes.string,
  emailWhenBackFormProductID: PropTypes.string,
  flexibleCreditTooltipProductID: PropTypes.string,
  dataInteraction: PropTypes.string,
  onProductIntersection: PropTypes.func
};

ProductList.defaultProps = {
  countdownClassSuffix: undefined,
  emailWhenBackFormProductID: undefined,
  flexibleCreditTooltipProductID: null,
  dataInteraction: undefined,
  onProductIntersection: undefined
};

function mapStateToProps(state) {
  return {
    countdownClassSuffix: state.listingPage.pageSetup.countdownClassSuffix,
    productsList: getCurrentProductList(),
    emailWhenBackFormProductID: state.listingPage.products.emailWhenBackFormProductID,
    flexibleCreditTooltipProductID: state.listingPage.products.flexibleCreditTooltipProductID
  };
}

export { ProductList as ProductListBlock };
export default connect(mapStateToProps)(ProductList);

